import { useState, useEffect, useContext } from 'react'
import styles from './styles.module.css'
import { Input, Select } from '../../../components/ModalInputs'
import Button from '../../../components/Button'
import Table from '../../../components/Table'
import { StaffRosterContext } from '../../../utils/context'
import { useSelector } from 'react-redux'

const API_TAB = 'foreign_languages'

// Данные для дропдаунов
const languagesList = [
  { name: '', value: '' },
  { name: 'Английский', value: 'english' },
  { name: 'Немецкий', value: 'german' },
  { name: 'Французский', value: 'french' },
  { name: 'Испанский', value: 'spanish' },
  { name: 'Итальянский', value: 'italian' },
  { name: 'Китайский', value: 'chinese' },
  { name: 'Японский', value: 'japanese' },
  { name: 'Арабский', value: 'arabic' }
]

const proficiencyLevels = [
  { name: '', value: '' },
  { name: 'Читаю со словарем', value: 'dictionary' },
  { name: 'Читаю и могу объясняться', value: 'basic' },
  { name: 'Владею свободно', value: 'fluent' },
  { name: 'Родной язык', value: 'native' }
]

export default function Languages() {
  const { allForms, trackDeletion } = useContext(StaffRosterContext)
  const { values, setFieldValue } = allForms

  // Данные из API (Redux)
  const { personTabData } = useSelector(state => state.personnel)
  const { languages: apiLanguages } = personTabData || {}

  const [formData, setFormData] = useState({
    language: '',
    proficiency: ''
  })

  const [selectedRow, setSelectedRow] = useState(null)

  // Данные таблицы берем из Formik
  const tableData = values.languages || []

  // Синхронизация API данных с Formik (только при первой загрузке)
  useEffect(() => {
    if (apiLanguages && !tableData.length) {
      setFieldValue('languages', apiLanguages)
    }
  }, [apiLanguages, tableData.length, setFieldValue])

  const handleFormChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
  }

  const handleRowSelect = (id) => {
    setSelectedRow(selectedRow === id ? null : id)
  }

  const handleAddRow = () => {
    const newRow = {
      id: `new_${Date.now()}`,
      language: formData.language,
      proficiency_level: formData.proficiency
    }
    // Сохраняем в Formik
    setFieldValue('languages', [...tableData, newRow])
  }

  const handleDeleteRow = () => {
    if (selectedRow !== null) {
      const rowToDelete = tableData.find(row => (row.id || row.xp_key) === selectedRow)
      if (rowToDelete) {
        const pk = rowToDelete.xp_key || rowToDelete.id || rowToDelete.xp_fm_id
        if (pk && !String(pk).startsWith('new_')) {
          trackDeletion(API_TAB, pk)
        }
      }
      // Обновляем в Formik
      const updatedData = tableData.filter(row => (row.id || row.xp_key) !== selectedRow)
      setFieldValue('languages', updatedData)
      setSelectedRow(null)
    }
  }

  const renderOptions = ({ name, value }) => (
    <option key={value || 'empty'} value={value}>{name}</option>
  )

  return (
    <div className={styles.tabWrapper}>
      {/* Форма */}
      <div className={styles.qualificationForm}>
        <div className={styles.inputsRow}>
          <Select
            label="Иностранный язык"
            name="language"
            value={formData.language}
            onChange={handleFormChange}
          >
            {languagesList.map(renderOptions)}
          </Select>
          <Select
            label="Степень знания"
            name="proficiency"
            value={formData.proficiency}
            onChange={handleFormChange}
          >
            {proficiencyLevels.map(renderOptions)}
          </Select>
          <div className={styles.qualificationButtonsInline}>
            <Button onClick={handleAddRow}>+ Добавить строку</Button>
            <Button mode="delete" onClick={handleDeleteRow}>× Удалить строку</Button>
          </div>
        </div>
      </div>

      {/* Таблица */}
      <div className={styles.qualificationTableSection}>
        <Table>
          <thead>
            <tr>
              <th>Иностранный язык</th>
              <th>Степень знания</th>
            </tr>
          </thead>
          <tbody>
            {tableData.length > 0 ? (
              tableData.map(row => {
                const rowId = row.id || row.xp_key
                return (
                  <tr
                    key={rowId}
                    onClick={() => handleRowSelect(rowId)}
                    className={selectedRow === rowId ? styles.selectedRow : ''}
                  >
                    <td>{row.language}</td>
                    <td>{row.proficiency_level || row.proficiency}</td>
                  </tr>
                )
              })
            ) : (
              <tr>
                <td colSpan="2" className={styles.emptyTable}>
                  Нет данных о знании языков
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    </div>
  )
}
